/**
 * Created by smizrahi on 7/29/16.
 */

export default class ConfigGps {
    constructor(enabled = false, geocodingEnabled = false, searchTime = 30, accuracy = 1000) {
        if(typeof(enabled) === "boolean") {
            this.enabled = enabled
        } else {
            this.enabled = (enabled === 'true');
        }

        if(typeof(geocodingEnabled) === "boolean") {
            this.geocodingEnabled = geocodingEnabled
        } else {
            this.geocodingEnabled = (geocodingEnabled === 'true');
        }

        this.searchTime = parseInt(searchTime);
        this.accuracy = parseInt(accuracy);
        Object.freeze(this);
    }

    static restore(obj) {
        return new ConfigGps(
            obj.enabled,
            obj.geocodingEnabled,
            obj.searchTime,
            obj.accuracy);
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/config/ConfigGps.js